var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyFamilyDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 747 396",
    width: 747,
    height: 396,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "happy family day wizard for family day") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2536 1608h2367.88v-1889.19h-2367.88z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0254ec } \n\t\t.s1 { fill: #0556ec;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s2 { fill: #0758ed;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s3 { fill: #0a59ed;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s4 { fill: #0c5bed;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s5 { fill: #0f5ded;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s6 { fill: #115fee;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s7 { fill: #1461ee;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s8 { fill: #1762ee;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s9 { fill: #1964ee;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s10 { fill: #1c66ef;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s11 { fill: #1e68ef;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .5 } \n\t\t.s12 { fill: #2169ef;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .5 } \n\t\t.s13 { fill: #236bef;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .5 } \n\t\t.s14 { fill: #266df0;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .6 } \n\t\t.s15 { fill: #286ff0;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .6 } \n\t\t.s16 { fill: #2b71f0;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .7 } \n\t\t.s17 { fill: #2e72f1;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .7 } \n\t\t.s18 { fill: #3074f1;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .8 } \n\t\t.s19 { fill: #3376f1;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .8 } \n\t\t.s20 { fill: #3578f1;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .8 } \n\t\t.s21 { fill: #387af2;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .9 } \n\t\t.s22 { fill: #3a7bf2;stroke: #0254ec;stroke-miterlimit:10;stroke-width: .9 } \n\t\t.s23 { fill: #3d7df2;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1 } \n\t\t.s24 { fill: #407ff2;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1 } \n\t\t.s25 { fill: #4281f3;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.1 } \n\t\t.s26 { fill: #4583f3;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.1 } \n\t\t.s27 { fill: #4784f3;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.1 } \n\t\t.s28 { fill: #4a86f3;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.2 } \n\t\t.s29 { fill: #4c88f4;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.2 } \n\t\t.s30 { fill: #4f8af4;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.3 } \n\t\t.s31 { fill: #518bf4;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.3 } \n\t\t.s32 { fill: #548df5;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.4 } \n\t\t.s33 { fill: #578ff5;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.4 } \n\t\t.s34 { fill: #5991f5;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.4 } \n\t\t.s35 { fill: #5c93f5;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.5 } \n\t\t.s36 { fill: #5e94f6;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.5 } \n\t\t.s37 { fill: #6196f6;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.6 } \n\t\t.s38 { fill: #6398f6;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.6 } \n\t\t.s39 { fill: #669af6;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.6 } \n\t\t.s40 { fill: #699cf7;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.7 } \n\t\t.s41 { fill: #6b9df7;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.7 } \n\t\t.s42 { fill: #6e9ff7;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.8 } \n\t\t.s43 { fill: #70a1f8;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.8 } \n\t\t.s44 { fill: #73a3f8;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.9 } \n\t\t.s45 { fill: #75a4f8;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.9 } \n\t\t.s46 { fill: #78a6f8;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 1.9 } \n\t\t.s47 { fill: #7aa8f9;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s48 { fill: #7daaf9;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s49 { fill: #80acf9;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.1 } \n\t\t.s50 { fill: #82adf9;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.1 } \n\t\t.s51 { fill: #85affa;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.2 } \n\t\t.s52 { fill: #87b1fa;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.2 } \n\t\t.s53 { fill: #8ab3fa;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.2 } \n\t\t.s54 { fill: #8cb5fa;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.3 } \n\t\t.s55 { fill: #8fb6fb;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.3 } \n\t\t.s56 { fill: #92b8fb;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.4 } \n\t\t.s57 { fill: #94bafb;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.4 } \n\t\t.s58 { fill: #97bcfc;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.5 } \n\t\t.s59 { fill: #99befc;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.5 } \n\t\t.s60 { fill: #9cbffc;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.5 } \n\t\t.s61 { fill: #9ec1fc;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.6 } \n\t\t.s62 { fill: #a1c3fd;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.6 } \n\t\t.s63 { fill: #a3c5fd;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.7 } \n\t\t.s64 { fill: #a6c6fd;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.7 } \n\t\t.s65 { fill: #a9c8fd;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.7 } \n\t\t.s66 { fill: #abcafe;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.8 } \n\t\t.s67 { fill: #aeccfe;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.8 } \n\t\t.s68 { fill: #b0cefe;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.9 } \n\t\t.s69 { fill: #b3cffe;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 2.9 } \n\t\t.s70 { fill: #b5d1ff;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 3 } \n\t\t.s71 { fill: #b8d3ff;stroke: #0254ec;stroke-miterlimit:10;stroke-width: 3 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m33.8 73.2h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m121.4 113.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m220.5 113.6h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m301.1 113.6h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m381.9 113.6h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m33.8 209.6h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m126.1 150.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m272 249.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m284.1 249.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m319.1 150.5v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m433.2 150.5l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m578.9 199.9c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m634.1 150.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m718.4 150.5l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m100.3 350.4l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m144.9 385.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m245.5 303.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m307.2 286.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m403.8 344.8l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m510.7 309.8c3.6 7.4 5.4 16.1 5.4 25.9 0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m550.7 286.2h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m538.9 360c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m33.8 73h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m121.4 113.5h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m220.5 113.5h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m301.1 113.5h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m381.9 113.5h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m33.8 209.4h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m126.1 150.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m272 249.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m284.1 249.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m319.1 150.3v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m433.2 150.3l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m578.9 199.8c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m634.1 150.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m718.4 150.3l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m100.3 350.2l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m144.9 385h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m245.5 303v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m307.2 286.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m403.8 344.7l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m510.7 309.7c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m550.7 286.1h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m538.9 359.9c-4 0-7.3 1.2-9.9 3.7-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m33.8 72.9h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m121.4 113.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m220.5 113.4h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m301.1 113.4h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m381.9 113.4h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m33.8 209.3h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m126.1 150.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m272 249.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m284.1 249.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m319.1 150.2v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m433.2 150.2l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m578.9 199.6c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m634.1 150.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m718.4 150.2l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m100.3 350.1l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m144.9 384.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m245.5 302.8v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m307.2 285.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m403.8 344.5l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m510.7 309.6c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m550.7 285.9h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m538.9 359.7c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m33.8 72.7h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m121.4 113.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m220.5 113.2h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m301.1 113.2h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m381.9 113.2h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m33.8 209.1h34.8v-19.4h-34.8v-20h43v-19.7h-66v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m126.1 150l36.1 99h-24.4l-7.5-21.6h-31.9l-7.6 21.6h-24.2l36.2-99zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m272 249v-99h-25l-27.4 55.3-27.7-55.3h-25v99h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m284.1 249h23v-99h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m319.1 150v99h64.2v-19.3h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m433.2 150l-18.6 39-18.7-39h-26l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m578.9 199.5c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-99h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.5 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m634.1 150l36.2 99h-24.5l-7.4-21.6h-32l-7.5 21.6h-24.2l36.1-99zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.4 150l-18.6 39-18.6-39h-26.1l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m100.3 350l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m144.9 384.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m245.5 302.7v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m307.2 285.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m403.8 344.4l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m510.7 309.4c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m550.7 285.8h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m538.9 359.6c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m33.8 72.6h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m121.4 113.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m220.5 113.1h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m301.1 113.1h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m381.9 113.1h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m33.8 209h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m126.1 149.9l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m272 248.8v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m284.1 248.8h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m319.1 149.9v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m433.2 149.9l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m578.9 199.4c0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m634.1 149.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m718.4 149.9l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m100.3 349.8l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m144.9 384.5h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m245.5 302.5v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m307.2 285.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m403.8 344.3l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m510.7 309.3c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m550.7 285.6h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m538.9 359.4c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m33.8 72.5h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m121.4 112.9h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m220.5 112.9h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m301.1 112.9h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m381.9 112.9h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m33.8 208.9h34.8v-19.5h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m126.1 149.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m272 248.7v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m284.1 248.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m319.1 149.8v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m433.2 149.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m578.9 199.2c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m634.1 149.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m718.4 149.8l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m100.3 349.7l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m144.9 384.4h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m245.5 302.4v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m307.2 285.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m403.8 344.1l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m510.7 309.1c3.6 7.4 5.4 16.1 5.4 25.8 0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m550.7 285.5h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m538.9 359.3c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m33.8 72.3h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m121.4 112.8h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m220.5 112.8h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m301.1 112.8h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m381.9 112.8h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m33.8 208.7h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m126.1 149.6l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m272 248.5v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m284.1 248.5h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m319.1 149.6v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m433.2 149.6l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m578.9 199.1c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m634.1 149.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m718.4 149.6l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m100.3 349.5l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m144.9 384.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m245.5 302.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m307.2 285.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m403.8 344l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s6",
    d: "m510.7 309c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m550.7 285.4h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m538.9 359.1c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m33.8 72.2h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m121.4 112.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m220.5 112.7h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m301.1 112.7h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m381.9 112.7h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m33.8 208.6h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m126.1 149.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m272 248.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m284.1 248.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m319.1 149.5v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m433.2 149.5l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m578.9 198.9c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m634.1 149.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m718.4 149.5l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m100.3 349.4l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m144.9 384.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m245.5 302.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m307.2 285.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m403.8 343.8l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s7",
    d: "m510.7 308.9c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m550.7 285.2h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m538.9 359c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m33.8 72h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m121.4 112.5h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m220.5 112.5h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.5 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16 0 5.7-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m301.1 112.5h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.5 12.1 11.4 2.7 4.8 4 10.2 4 16 0 5.7-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m381.9 112.5h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m33.8 208.4h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m126.1 149.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m272 248.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m284.1 248.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m319.1 149.3v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m433.2 149.3l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m578.9 198.8c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m634.1 149.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m718.4 149.3l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m100.3 349.3l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m144.9 384h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m245.5 302v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m307.2 285.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m403.8 343.7l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m510.7 308.7c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m550.7 285.1h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m538.9 358.9c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m33.8 71.9h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m121.4 112.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m220.5 112.4h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m301.1 112.4h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m381.9 112.4h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m33.8 208.3h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m126.1 149.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m272 248.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m284.1 248.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m319.1 149.2v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m433.2 149.2l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m578.9 198.7c0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m634.1 149.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m718.4 149.2l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m100.3 349.1l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m144.9 383.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m245.5 301.8v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m307.2 284.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m403.8 343.6l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s9",
    d: "m510.7 308.6c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m550.7 284.9h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m538.9 358.7c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m33.8 71.8h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m121.4 112.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m220.5 112.2h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m301.1 112.2h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m381.9 112.2h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m33.8 208.1h34.8v-19.4h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m126.1 149.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m272 248v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m284.1 248h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m319.1 149.1v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m433.2 149.1l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m578.9 198.5c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m634.1 149.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m718.4 149.1l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m100.3 349l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m144.9 383.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m245.5 301.7v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m307.2 284.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m403.8 343.4l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s10",
    d: "m510.7 308.4c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.6-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m550.7 284.8h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m538.9 358.6c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.1 2.6 2.6 5.9 3.8 9.9 3.8 3.8 0 7-1.2 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m33.8 71.6h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m121.4 112.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m220.5 112.1h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.9-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m301.1 112.1h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.9-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m381.9 112.1h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m33.8 208h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m126.1 148.9l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m272 247.8v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m284.1 247.8h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m319.1 148.9v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m433.2 148.9l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m578.9 198.4c0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m634.1 148.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m718.4 148.9l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m100.3 348.8l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 99h24.7l16.6-60.5 16.2 60.5h24.8l26.8-99h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m144.9 383.6h22.9v-99h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m245.5 301.5v-16.9h-68v20.2h39.8l-40.2 61.9v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m307.2 284.6l36.2 99h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-99zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m403.8 343.3l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-99h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s11",
    d: "m510.7 308.3c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-99h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.5 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m550.7 284.6h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m538.9 358.4c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m33.8 71.5h35.7v40.5h23v-99h-23v38.7h-35.7v-38.7h-23v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m121.4 112h-24.2l36.2-99h23.3l36.2 99h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m220.5 112h-22.9v-99h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m301.1 112h-23v-99h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m381.9 112h23v-35.4l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m33.8 207.9h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m126.1 148.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m272 247.7v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m284.1 247.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m319.1 148.8v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m433.2 148.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m578.9 198.2c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m634.1 148.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m718.4 148.8l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m100.3 348.7l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m144.9 383.4h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m245.5 301.4v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m307.2 284.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m403.8 343.1l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s12",
    d: "m510.7 308.2c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.6zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m550.7 284.5h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m538.9 358.3c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m33.8 71.3h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m121.4 111.8h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m220.5 111.8h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.8 3.9 10.2 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m301.1 111.8h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.8 4 10.2 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m381.9 111.8h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m33.8 207.7h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m126.1 148.6l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m272 247.5v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m284.1 247.5h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m319.1 148.6v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m433.2 148.6l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m578.9 198.1c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m634.1 148.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m718.4 148.6l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m100.3 348.6l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m144.9 383.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m245.5 301.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m307.2 284.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m403.8 343l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m510.7 308c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m550.7 284.4h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m538.9 358.2c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m33.8 71.2h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m121.4 111.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m220.5 111.7h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.6-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m301.1 111.7h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.6-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m381.9 111.7h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m33.8 207.6h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m126.1 148.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m272 247.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m284.1 247.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m319.1 148.5v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m433.2 148.5l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m578.9 197.9c0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m634.1 148.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m718.4 148.5l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m100.3 348.4l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m144.9 383.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m245.5 301.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m307.2 284.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m403.8 342.8l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s14",
    d: "m510.7 307.9c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m550.7 284.2h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m538.9 358c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m33.8 71h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m121.4 111.5h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m220.5 111.5h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m301.1 111.5h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m381.9 111.5h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m33.8 207.4h34.8v-19.4h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m126.1 148.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m272 247.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m284.1 247.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m319.1 148.4v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m433.2 148.4l-18.6 38.9-18.7-38.9h-26l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m578.9 197.8c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m634.1 148.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m718.4 148.4l-18.6 38.9-18.6-38.9h-26.1l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m100.3 348.3l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m144.9 383h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m245.5 301v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m307.2 284.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m403.8 342.7l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s15",
    d: "m510.7 307.7c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m550.7 284.1h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m538.9 357.9c-4 0-7.3 1.2-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.3-2.6-2.6-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m33.8 70.9h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m121.4 111.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m220.5 111.4h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.5 0-3.9-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m301.1 111.4h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.5 0-3.9-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m381.9 111.4h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m33.8 207.3h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m126.1 148.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m272 247.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m284.1 247.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m319.1 148.2v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m433.2 148.2l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m578.9 197.7c0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m634.1 148.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m718.4 148.2l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m100.3 348.1l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m144.9 382.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m245.5 300.8v-16.9h-68v20.2h39.8l-40.2 61.9v16.8h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m307.2 283.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m403.8 342.6l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s16",
    d: "m510.7 307.6c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m550.7 283.9h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m538.9 357.7c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m33.8 70.8h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m121.4 111.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m220.5 111.2h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m301.1 111.2h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m381.9 111.2h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m33.8 207.2h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m126.1 148.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m272 247v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m284.1 247h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m319.1 148.1v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m433.2 148.1l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m578.9 197.5c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m634.1 148.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m718.4 148.1l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m100.3 348l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m144.9 382.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m245.5 300.7v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m307.2 283.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m403.8 342.4l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s17",
    d: "m510.7 307.4c3.6 7.4 5.4 16.1 5.4 25.9 0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m550.7 283.8h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m538.9 357.6c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m33.8 70.6h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m121.4 111.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m220.5 111.1h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.8 3.9 10.2 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m301.1 111.1h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.8 4 10.2 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m381.9 111.1h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m33.8 207h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m126.1 147.9l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m272 246.8v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m284.1 246.8h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m319.1 147.9v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m433.2 147.9l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m578.9 197.4c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m634.1 147.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m718.4 147.9l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m100.3 347.9l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m144.9 382.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m245.5 300.6v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m307.2 283.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m403.8 342.3l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m510.7 307.3c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m550.7 283.7h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m538.9 357.5c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m33.8 70.5h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m121.4 111h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m220.5 111h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m301.1 111h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m381.9 111h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m33.8 206.9h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m126.1 147.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m272 246.7v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m284.1 246.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m319.1 147.8v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m433.2 147.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m578.9 197.2c0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m634.1 147.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m718.4 147.8l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m100.3 347.7l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m144.9 382.4h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m245.5 300.4v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m307.2 283.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m403.8 342.1l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s19",
    d: "m510.7 307.2c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m550.7 283.5h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m538.9 357.3c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m33.8 70.3h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m121.4 110.8h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m220.5 110.8h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m301.1 110.8h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m381.9 110.8h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m33.8 206.7h34.8v-19.4h-34.8v-20h43v-19.7h-66v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m126.1 147.6l36.1 99h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-99zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m272 246.6v-99h-25l-27.4 55.3-27.7-55.3h-25v99h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m284.1 246.6h23v-99h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m319.1 147.6v99h64.2v-19.3h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m433.2 147.6l-18.6 39-18.7-39h-26l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m578.9 197.1c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-99h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.5 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m634.1 147.6l36.2 99h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-99zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m718.4 147.6l-18.6 39-18.6-39h-26.1l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m100.3 347.6l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m144.9 382.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m245.5 300.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m307.2 283.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m403.8 342l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s20",
    d: "m510.7 307c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m550.7 283.4h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m538.9 357.2c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m33.8 70.2h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m121.4 110.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m220.5 110.7h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m301.1 110.7h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m381.9 110.7h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m33.8 206.6h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m126.1 147.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m272 246.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m284.1 246.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m319.1 147.5v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m433.2 147.5l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m578.9 197c0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.6 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m634.1 147.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m718.4 147.5l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m100.3 347.4l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m144.9 382.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m245.5 300.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m307.2 283.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m403.8 341.9l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s21",
    d: "m510.7 306.9c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m550.7 283.2h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m538.9 357c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m33.8 70.1h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m121.4 110.5h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m220.5 110.5h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m301.1 110.5h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m381.9 110.5h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m33.8 206.5h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m126.1 147.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m272 246.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m284.1 246.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m319.1 147.4v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m433.2 147.4l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m578.9 196.8c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m634.1 147.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m718.4 147.4l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m100.3 347.3l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m144.9 382h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m245.5 300v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m307.2 283.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m403.8 341.7l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s22",
    d: "m510.7 306.7c3.6 7.4 5.4 16.1 5.4 25.9 0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m550.7 283.1h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m538.9 356.9c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m33.8 69.9h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m121.4 110.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m220.5 110.4h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m301.1 110.4h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m381.9 110.4h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m33.8 206.3h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m126.1 147.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m272 246.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m284.1 246.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m319.1 147.2v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m433.2 147.2l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m578.9 196.7c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m634.1 147.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m718.4 147.2l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m100.3 347.1l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m144.9 381.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m245.5 299.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m307.2 283l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m403.8 341.6l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s23",
    d: "m510.7 306.6c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m550.7 283h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m538.9 356.8c-4 0-7.3 1.2-9.9 3.7-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m33.8 69.8h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m121.4 110.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m220.5 110.3h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m301.1 110.3h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m381.9 110.3h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m33.8 206.2h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m126.1 147.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m272 246v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m284.1 246h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m319.1 147.1v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m433.2 147.1l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m578.9 196.5c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m634.1 147.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m718.4 147.1l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m100.3 347l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m144.9 381.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m245.5 299.7v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m307.2 282.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m403.8 341.4l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s24",
    d: "m510.7 306.5c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m550.7 282.8h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m538.9 356.6c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m33.8 69.6h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m121.4 110.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m220.5 110.1h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16 0 5.7-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m301.1 110.1h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16 0 5.7-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m381.9 110.1h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m33.8 206h34.8v-19.4h-34.8v-20h43v-19.7h-66v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m126.1 146.9l36.1 99h-24.4l-7.5-21.6h-31.9l-7.6 21.6h-24.2l36.2-99zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m272 245.9v-99h-25l-27.4 55.3-27.7-55.3h-25v99h23v-54.7l21 41.4h17.1l21-41.4v54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m284.1 245.9h23v-99h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m319.1 146.9v99h64.2v-19.3h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m433.2 146.9l-18.6 39-18.7-39h-26l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m578.9 196.4c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-99h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.5 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m634.1 146.9l36.2 99h-24.5l-7.4-21.6h-32l-7.5 21.6h-24.2l36.1-99zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m718.4 146.9l-18.6 39-18.6-39h-26.1l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m100.3 346.9l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m144.9 381.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m245.5 299.6v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m307.2 282.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m403.8 341.3l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s25",
    d: "m510.7 306.3c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m550.7 282.7h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m538.9 356.5c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m33.8 69.5h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m121.4 110h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m220.5 110h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m301.1 110h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m381.9 110h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m33.8 205.9h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m126.1 146.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m272 245.7v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m284.1 245.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m319.1 146.8v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m433.2 146.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m578.9 196.3c0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m634.1 146.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m718.4 146.8l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m100.3 346.7l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m144.9 381.4h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m245.5 299.4v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m307.2 282.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m403.8 341.2l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s26",
    d: "m510.7 306.2c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m550.7 282.5h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m538.9 356.3c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m33.8 69.4h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m121.4 109.8h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m220.5 109.8h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m301.1 109.8h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m381.9 109.8h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m33.8 205.8h34.8v-19.5h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m126.1 146.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m272 245.6v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m284.1 245.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m319.1 146.7v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m433.2 146.7l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m578.9 196.1c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m634.1 146.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m718.4 146.7l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m100.3 346.6l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m144.9 381.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m245.5 299.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m307.2 282.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m403.8 341l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s27",
    d: "m510.7 306c3.6 7.4 5.4 16.1 5.4 25.8 0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m550.7 282.4h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m538.9 356.2c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m33.8 69.2h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m121.4 109.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m220.5 109.7h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m301.1 109.7h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m381.9 109.7h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m33.8 205.6h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m126.1 146.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m272 245.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m284.1 245.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m319.1 146.5v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m433.2 146.5l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m578.9 196c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m634.1 146.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m718.4 146.5l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m100.3 346.4l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m144.9 381.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m245.5 299.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m307.2 282.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m403.8 340.9l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m510.7 305.9c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m550.7 282.3h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s28",
    d: "m538.9 356c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m33.8 69.1h35.7v40.5h23v-99h-23v38.7h-35.7v-38.7h-23v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m121.4 109.6h-24.2l36.2-99h23.3l36.2 99h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m220.5 109.6h-22.9v-99h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m301.1 109.6h-23v-99h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m381.9 109.6h23v-35.4l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m33.8 205.5h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m126.1 146.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m272 245.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m284.1 245.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m319.1 146.4v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m433.2 146.4l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m578.9 195.8c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m634.1 146.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m718.4 146.4l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m100.3 346.3l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m144.9 381h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m245.5 299v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m307.2 282.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m403.8 340.7l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s29",
    d: "m510.7 305.8c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m550.7 282.1h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m538.9 355.9c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m33.8 68.9h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m121.4 109.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m220.5 109.4h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.5 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16 0 5.7-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m301.1 109.4h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.5 12.1 11.4 2.7 4.8 4 10.2 4 16 0 5.7-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m381.9 109.4h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m33.8 205.3h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m126.1 146.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m272 245.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m284.1 245.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m319.1 146.2v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m433.2 146.2l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m578.9 195.7c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m634.1 146.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m718.4 146.2l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m100.3 346.2l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m144.9 380.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m245.5 298.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m307.2 282l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m403.8 340.6l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s30",
    d: "m510.7 305.6c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m550.7 282h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m538.9 355.8c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m33.8 68.8h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m121.4 109.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m220.5 109.3h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m301.1 109.3h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m381.9 109.3h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m33.8 205.2h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m126.1 146.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m272 245v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m284.1 245h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m319.1 146.1v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m433.2 146.1l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m578.9 195.6c0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m634.1 146.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m718.4 146.1l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m100.3 346l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m144.9 380.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m245.5 298.7v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m307.2 281.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m403.8 340.5l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s31",
    d: "m510.7 305.5c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m550.7 281.8h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m538.9 355.6c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m33.8 68.7h35.7v40.4h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m121.4 109.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m220.5 109.1h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m301.1 109.1h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m381.9 109.1h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m33.8 205h34.8v-19.4h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m126.1 146l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m272 244.9v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m284.1 244.9h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m319.1 146v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m433.2 146l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m578.9 195.4c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m634.1 146l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m718.4 146l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m100.3 345.9l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m144.9 380.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m245.5 298.6v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m307.2 281.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m403.8 340.3l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s32",
    d: "m510.7 305.3c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.6-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m550.7 281.7h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m538.9 355.5c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.1 2.6 2.6 5.9 3.8 9.9 3.8 3.8 0 7-1.2 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m33.8 68.5h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m121.4 109h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m220.5 109h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.9-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m301.1 109h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.9-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m381.9 109h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m33.8 204.9h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m126.1 145.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m272 244.7v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m284.1 244.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m319.1 145.8v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m433.2 145.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m578.9 195.3c0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m634.1 145.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m718.4 145.8l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m100.3 345.7l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 99h24.7l16.6-60.5 16.2 60.5h24.8l26.8-99h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m144.9 380.5h22.9v-99h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m245.5 298.4v-16.9h-68v20.2h39.8l-40.2 61.9v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m307.2 281.5l36.2 99h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-99zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m403.8 340.2l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-99h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s33",
    d: "m510.7 305.2c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-99h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.3 6.6-5.3 8.3-9.5 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m550.7 281.5h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m538.9 355.3c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m33.8 68.4h35.7v40.5h23v-99h-23v38.7h-35.7v-38.7h-23v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m121.4 108.9h-24.2l36.2-99h23.3l36.2 99h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m220.5 108.9h-22.9v-99h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m301.1 108.9h-23v-99h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m381.9 108.9h23v-35.4l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m33.8 204.8h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m126.1 145.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m272 244.6v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m284.1 244.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m319.1 145.7v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m433.2 145.7l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m578.9 195.1c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m634.1 145.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m718.4 145.7l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m100.3 345.6l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m144.9 380.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m245.5 298.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m307.2 281.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m403.8 340l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s34",
    d: "m510.7 305.1c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.6zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m550.7 281.4h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m538.9 355.2c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m33.8 68.2h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m121.4 108.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m220.5 108.7h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.8 3.9 10.2 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m301.1 108.7h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.8 4 10.2 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m381.9 108.7h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m33.8 204.6h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m126.1 145.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m272 244.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m284.1 244.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m319.1 145.5v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m433.2 145.5l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m578.9 195c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m634.1 145.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m718.4 145.5l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m100.3 345.5l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m144.9 380.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m245.5 298.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m307.2 281.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m403.8 339.9l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s35",
    d: "m510.7 304.9c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m550.7 281.3h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m538.9 355.1c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m33.8 68.1h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m121.4 108.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m220.5 108.6h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.6-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m301.1 108.6h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.6-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m381.9 108.6h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m33.8 204.5h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m126.1 145.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m272 244.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m284.1 244.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m319.1 145.4v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m433.2 145.4l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m578.9 194.8c0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m634.1 145.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m718.4 145.4l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m100.3 345.3l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m144.9 380h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m245.5 298v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m307.2 281.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m403.8 339.7l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s36",
    d: "m510.7 304.8c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m550.7 281.1h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m538.9 354.9c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m33.8 67.9h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m121.4 108.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m220.5 108.4h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m301.1 108.4h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m381.9 108.4h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m33.8 204.3h34.8v-19.4h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m126.1 145.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m272 244.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m284.1 244.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m319.1 145.3v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m433.2 145.3l-18.6 38.9-18.7-38.9h-26l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m578.9 194.7c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m634.1 145.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m718.4 145.3l-18.6 38.9-18.6-38.9h-26.1l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m100.3 345.2l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m144.9 379.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m245.5 297.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m307.2 281l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m403.8 339.6l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s37",
    d: "m510.7 304.6c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m550.7 281h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m538.9 354.8c-4 0-7.3 1.2-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.3-2.6-2.6-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m33.8 67.8h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m121.4 108.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m220.5 108.3h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.6-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m301.1 108.3h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.6-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m381.9 108.3h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m33.8 204.2h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m126.1 145.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m272 244v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m284.1 244h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m319.1 145.1v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m433.2 145.1l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m578.9 194.6c0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m634.1 145.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m718.4 145.1l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m100.3 345l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m144.9 379.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m245.5 297.7v-16.9h-68v20.2h39.8l-40.2 61.9v16.8h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m307.2 280.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m403.8 339.5l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s38",
    d: "m510.7 304.5c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m550.7 280.8h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m538.9 354.6c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m33.8 67.7h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m121.4 108.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m220.5 108.1h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m301.1 108.1h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m381.9 108.1h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m33.8 204.1h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m126.1 145l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m272 243.9v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m284.1 243.9h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m319.1 145v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m433.2 145l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m578.9 194.4c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m634.1 145l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m718.4 145l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m100.3 344.9l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m144.9 379.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m245.5 297.6v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m307.2 280.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m403.8 339.3l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s39",
    d: "m510.7 304.3c3.6 7.4 5.4 16.1 5.4 25.9 0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m550.7 280.7h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m538.9 354.5c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m33.8 67.5h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m121.4 108h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m220.5 108h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.8 3.9 10.2 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m301.1 108h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.8 4 10.2 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m381.9 108h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m33.8 203.9h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m126.1 144.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m272 243.7v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m284.1 243.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m319.1 144.8v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m433.2 144.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m578.9 194.3c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m634.1 144.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m718.4 144.8l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m100.3 344.7l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m144.9 379.5h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m245.5 297.5v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m307.2 280.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m403.8 339.2l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s40",
    d: "m510.7 304.2c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m550.7 280.6h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m538.9 354.4c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m33.8 67.4h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m121.4 107.9h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m220.5 107.9h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m301.1 107.9h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m381.9 107.9h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m33.8 203.8h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m126.1 144.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m272 243.6v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m284.1 243.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m319.1 144.7v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m433.2 144.7l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m578.9 194.1c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.6-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m634.1 144.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m718.4 144.7l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m100.3 344.6l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m144.9 379.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m245.5 297.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m307.2 280.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m403.8 339l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s41",
    d: "m510.7 304.1c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m550.7 280.4h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s41",
    d: "m538.9 354.2c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m33.8 67.2h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m121.4 107.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m220.5 107.7h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m301.1 107.7h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m381.9 107.7h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m33.8 203.6h34.8v-19.4h-34.8v-20h43v-19.7h-66v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m126.1 144.5l36.1 99h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-99zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m272 243.5v-99h-25l-27.4 55.3-27.7-55.3h-25v99h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m284.1 243.5h23v-99h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m319.1 144.5v99h64.2v-19.3h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m433.2 144.5l-18.6 39-18.7-39h-26l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m578.9 194c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-99h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.5 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m634.1 144.5l36.2 99h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-99zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m718.4 144.5l-18.6 39-18.6-39h-26.1l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m100.3 344.5l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m144.9 379.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m245.5 297.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m307.2 280.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m403.8 338.9l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s42",
    d: "m510.7 303.9c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m550.7 280.3h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s42",
    d: "m538.9 354.1c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m33.8 67.1h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m121.4 107.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m220.5 107.6h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m301.1 107.6h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m381.9 107.6h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m33.8 203.5h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m126.1 144.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m272 243.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m284.1 243.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m319.1 144.4v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m433.2 144.4l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m578.9 193.9c0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.6 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m634.1 144.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m718.4 144.4l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m100.3 344.3l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m144.9 379h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m245.5 297v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m307.2 280.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m403.8 338.8l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s43",
    d: "m510.7 303.8c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m550.7 280.1h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s43",
    d: "m538.9 353.9c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m33.8 67h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m121.4 107.4h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m220.5 107.4h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m301.1 107.4h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m381.9 107.4h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m33.8 203.4h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m126.1 144.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m272 243.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m284.1 243.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m319.1 144.3v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m433.2 144.3l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m578.9 193.7c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m634.1 144.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m718.4 144.3l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m100.3 344.2l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m144.9 378.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m245.5 296.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m307.2 280l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m403.8 338.6l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s44",
    d: "m510.7 303.6c3.6 7.4 5.4 16.1 5.4 25.8 0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m550.7 280h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s44",
    d: "m538.9 353.8c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m33.8 66.8h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m121.4 107.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m220.5 107.3h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m301.1 107.3h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m381.9 107.3h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m33.8 203.2h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m126.1 144.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m272 243v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m284.1 243h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m319.1 144.1v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m433.2 144.1l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m578.9 193.6c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m634.1 144.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m718.4 144.1l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m100.3 344l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m144.9 378.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m245.5 296.8v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m307.2 279.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m403.8 338.5l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s45",
    d: "m510.7 303.5c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m550.7 279.9h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s45",
    d: "m538.9 353.6c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m33.8 66.7h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m121.4 107.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m220.5 107.2h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m301.1 107.2h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m381.9 107.2h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m33.8 203.1h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m126.1 144l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m272 242.9v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m284.1 242.9h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m319.1 144v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m433.2 144l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m578.9 193.4c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m634.1 144l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m718.4 144l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m100.3 343.9l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m144.9 378.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m245.5 296.6v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m307.2 279.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m403.8 338.3l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s46",
    d: "m510.7 303.4c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m550.7 279.7h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s46",
    d: "m538.9 353.5c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m33.8 66.5h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m121.4 107h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m220.5 107h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16 0 5.7-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m301.1 107h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16 0 5.7-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m381.9 107h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m33.8 202.9h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m126.1 143.8l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m272 242.7v-98.9h-25l-27.4 55.3-27.7-55.3h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m284.1 242.7h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m319.1 143.8v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m433.2 143.8l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m578.9 193.3c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m634.1 143.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m718.4 143.8l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m100.3 343.8l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m144.9 378.5h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m245.5 296.5v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m307.2 279.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m403.8 338.2l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s47",
    d: "m510.7 303.2c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m550.7 279.6h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s47",
    d: "m538.9 353.4c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m33.8 66.4h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m121.4 106.9h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m220.5 106.9h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m301.1 106.9h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m381.9 106.9h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m33.8 202.8h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m126.1 143.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m272 242.6v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m284.1 242.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m319.1 143.7v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m433.2 143.7l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m578.9 193.2c0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m634.1 143.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m718.4 143.7l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m100.3 343.6l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m144.9 378.3h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m245.5 296.3v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m307.2 279.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m403.8 338.1l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s48",
    d: "m510.7 303.1c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m550.7 279.4h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s48",
    d: "m538.9 353.2c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m33.8 66.3h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m121.4 106.7h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m220.5 106.7h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m301.1 106.7h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m381.9 106.7h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m33.8 202.7h34.8v-19.5h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m126.1 143.6l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m272 242.5v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m284.1 242.5h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m319.1 143.6v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m433.2 143.6l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m578.9 193c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m634.1 143.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m718.4 143.6l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m100.3 343.5l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m144.9 378.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m245.5 296.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m307.2 279.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m403.8 337.9l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s49",
    d: "m510.7 302.9c3.6 7.4 5.4 16.1 5.4 25.8 0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m550.7 279.3h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s49",
    d: "m538.9 353.1c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m33.8 66.1h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m121.4 106.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m220.5 106.6h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m301.1 106.6h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m381.9 106.6h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m33.8 202.5h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m126.1 143.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m272 242.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m284.1 242.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m319.1 143.4v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m433.2 143.4l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m578.9 192.9c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m634.1 143.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m718.4 143.4l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m100.3 343.3l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m144.9 378.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m245.5 296.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m307.2 279.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m403.8 337.8l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.7 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s50",
    d: "m510.7 302.8c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m550.7 279.2h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s50",
    d: "m538.9 352.9c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m33.8 66h35.7v40.5h23v-99h-23v38.7h-35.7v-38.7h-23v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m121.4 106.5h-24.2l36.2-99h23.3l36.2 99h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m220.5 106.5h-22.9v-99h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m301.1 106.5h-23v-99h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m381.9 106.5h23v-35.4l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m33.8 202.4h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m126.1 143.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m272 242.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m284.1 242.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m319.1 143.3v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m433.2 143.3l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m578.9 192.7c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m634.1 143.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m718.4 143.3l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m100.3 343.2l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m144.9 377.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m245.5 295.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m307.2 279l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m403.8 337.6l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s51",
    d: "m510.7 302.7c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m550.7 279h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s51",
    d: "m538.9 352.8c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m33.8 65.8h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m121.4 106.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m220.5 106.3h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.5 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16 0 5.7-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m301.1 106.3h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.5 12.1 11.4 2.7 4.8 4 10.2 4 16 0 5.7-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m381.9 106.3h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m33.8 202.2h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m126.1 143.1l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m272 242v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m284.1 242h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m319.1 143.1v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m433.2 143.1l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m578.9 192.6c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m634.1 143.1l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m718.4 143.1l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m100.3 343.1l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m144.9 377.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m245.5 295.8v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m307.2 278.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m403.8 337.5l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s52",
    d: "m510.7 302.5c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m550.7 278.9h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s52",
    d: "m538.9 352.7c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m33.8 65.7h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m121.4 106.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m220.5 106.2h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m301.1 106.2h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m381.9 106.2h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m33.8 202.1h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m126.1 143l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m272 241.9v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m284.1 241.9h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m319.1 143v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m433.2 143l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m578.9 192.5c0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m634.1 143l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m718.4 143l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m100.3 342.9l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m144.9 377.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m245.5 295.6v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m307.2 278.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m403.8 337.4l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s53",
    d: "m510.7 302.4c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m550.7 278.7h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s53",
    d: "m538.9 352.5c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m33.8 65.6h35.7v40.4h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m121.4 106h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m220.5 106h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m301.1 106h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m381.9 106h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m33.8 201.9h34.8v-19.4h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m126.1 142.9l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m272 241.8v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m284.1 241.8h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m319.1 142.9v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m433.2 142.9l-18.6 38.9-18.7-38.9h-26l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m578.9 192.3c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m634.1 142.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m718.4 142.9l-18.6 38.9-18.6-38.9h-26.1l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m100.3 342.8l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m144.9 377.5h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m245.5 295.5v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m307.2 278.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m403.8 337.2l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s54",
    d: "m510.7 302.2c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.6-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m550.7 278.6h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s54",
    d: "m538.9 352.4c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.1 2.6 2.6 5.9 3.8 9.9 3.8 3.8 0 7-1.2 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m33.8 65.4h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m121.4 105.9h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m220.5 105.9h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.9-1-6.7-3.1-8.7-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m301.1 105.9h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.9-0.9-6.7-3-8.7-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m381.9 105.9h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m33.8 201.8h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m126.1 142.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m272 241.6v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m284.1 241.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m319.1 142.7v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m433.2 142.7l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m578.9 192.2c0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m634.1 142.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m718.4 142.7l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m100.3 342.6l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 99h24.7l16.6-60.5 16.2 60.5h24.8l26.8-99h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m144.9 377.4h22.9v-99h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m245.5 295.3v-16.9h-68v20.2h39.8l-40.2 61.9v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m307.2 278.4l36.2 99h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-99zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m403.8 337.1l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-99h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s55",
    d: "m510.7 302.1c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-99h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.3 6.6-5.3 8.3-9.5 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m550.7 278.4h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s55",
    d: "m538.9 352.2c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m33.8 65.3h35.7v40.5h23v-99h-23v38.7h-35.7v-38.7h-23v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m121.4 105.8h-24.2l36.2-99h23.3l36.2 99h-24.5l-7.4-21.6h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m220.5 105.8h-22.9v-99h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m301.1 105.8h-23v-99h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m381.9 105.8h23v-35.4l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m33.8 201.7h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m126.1 142.6l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m272 241.5v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m284.1 241.5h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m319.1 142.6v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m433.2 142.6l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m578.9 192c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m634.1 142.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m718.4 142.6l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m100.3 342.5l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m144.9 377.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m245.5 295.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m307.2 278.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m403.8 336.9l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s56",
    d: "m510.7 301.9c3.6 7.4 5.4 16.1 5.4 25.9 0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m550.7 278.3h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s56",
    d: "m538.9 352.1c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m33.8 65.1h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m121.4 105.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m220.5 105.6h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.8 3.9 10.2 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m301.1 105.6h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.8 4 10.2 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m381.9 105.6h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m33.8 201.5h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m126.1 142.4l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m272 241.3v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m284.1 241.3h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m319.1 142.4v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m433.2 142.4l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m578.9 191.9c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m634.1 142.4l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m718.4 142.4l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m100.3 342.4l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m144.9 377.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m245.5 295.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m307.2 278.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m403.8 336.8l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s57",
    d: "m510.7 301.8c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m550.7 278.2h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s57",
    d: "m538.9 352c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m33.8 65h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m121.4 105.5h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m220.5 105.5h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.6-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m301.1 105.5h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.6-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m381.9 105.5h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m33.8 201.4h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m126.1 142.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m272 241.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m284.1 241.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m319.1 142.3v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m433.2 142.3l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m578.9 191.7c0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m634.1 142.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m718.4 142.3l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m100.3 342.2l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m144.9 376.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m245.5 294.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m307.2 278l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m403.8 336.6l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s58",
    d: "m510.7 301.7c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m550.7 278h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s58",
    d: "m538.9 351.8c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m33.8 64.8h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m121.4 105.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m220.5 105.3h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m301.1 105.3h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m381.9 105.3h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m33.8 201.2h34.8v-19.4h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m126.1 142.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m272 241.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m284.1 241.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m319.1 142.2v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m433.2 142.2l-18.6 38.9-18.7-38.9h-26l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m578.9 191.6c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m634.1 142.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m718.4 142.2l-18.6 38.9-18.6-38.9h-26.1l33.1 63.5v35.4h23v-35.4l33-63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m100.3 342.1l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m144.9 376.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m245.5 294.8v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m307.2 277.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m403.8 336.5l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s59",
    d: "m510.7 301.5c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m550.7 277.9h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s59",
    d: "m538.9 351.7c-4 0-7.3 1.2-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.3-2.6-2.6-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m33.8 64.7h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m121.4 105.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m220.5 105.2h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.6-2-2.1-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m301.1 105.2h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.6-2-2.1-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m381.9 105.2h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m33.8 201.1h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m126.1 142l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m272 240.9v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m284.1 240.9h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m319.1 142v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m433.2 142l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m578.9 191.5c0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m634.1 142l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m718.4 142l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m100.3 341.9l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m144.9 376.6h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m245.5 294.6v-16.9h-68v20.2h39.8l-40.2 61.9v16.8h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m307.2 277.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m403.8 336.4l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s60",
    d: "m510.7 301.4c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m550.7 277.7h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s60",
    d: "m538.9 351.5c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m33.8 64.6h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m121.4 105h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m220.5 105h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m301.1 105h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m381.9 105h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m33.8 201h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m126.1 141.9l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m272 240.8v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m284.1 240.8h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m319.1 141.9v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m433.2 141.9l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m578.9 191.3c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m634.1 141.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m718.4 141.9l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m100.3 341.8l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m144.9 376.5h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m245.5 294.5v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m307.2 277.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m403.8 336.2l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s61",
    d: "m510.7 301.2c3.6 7.4 5.4 16.1 5.4 25.9 0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m550.7 277.6h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s61",
    d: "m538.9 351.4c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m33.8 64.4h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m121.4 104.9h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m220.5 104.9h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.8 3.9 10.2 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m301.1 104.9h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.8 4 10.2 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m381.9 104.9h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m33.8 200.8h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m126.1 141.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m272 240.6v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m284.1 240.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m319.1 141.7v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m433.2 141.7l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m578.9 191.2c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m634.1 141.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m718.4 141.7l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m100.3 341.6l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m144.9 376.4h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m245.5 294.4v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m307.2 277.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m403.8 336.1l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s62",
    d: "m510.7 301.1c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m550.7 277.5h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s62",
    d: "m538.9 351.3c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.7-3.8-9.3-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m33.8 64.3h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m121.4 104.8h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m220.5 104.8h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m301.1 104.8h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m381.9 104.8h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m33.8 200.7h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m126.1 141.6l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m272 240.5v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m284.1 240.5h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m319.1 141.6v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m433.2 141.6l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m578.9 191c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.6-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m634.1 141.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m718.4 141.6l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m100.3 341.5l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m144.9 376.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m245.5 294.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m307.2 277.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.6h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m403.8 335.9l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s63",
    d: "m510.7 301c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m550.7 277.3h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s63",
    d: "m538.9 351.1c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m33.8 64.1h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m121.4 104.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m220.5 104.6h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m301.1 104.6h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m381.9 104.6h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m33.8 200.5h34.8v-19.4h-34.8v-20h43v-19.7h-66v99h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m126.1 141.4l36.1 99h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-99zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m272 240.4v-99h-25l-27.4 55.3-27.7-55.3h-25v99h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m284.1 240.4h23v-99h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m319.1 141.4v99h64.2v-19.3h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m433.2 141.4l-18.6 39-18.7-39h-26l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m578.9 190.9c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-99h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.5 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m634.1 141.4l36.2 99h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-99zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m718.4 141.4l-18.6 39-18.6-39h-26.1l33.1 63.6v35.4h23v-35.4l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m100.3 341.4l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m144.9 376.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m245.5 294.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m307.2 277.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m403.8 335.8l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s64",
    d: "m510.7 300.8c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.2 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m550.7 277.2h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s64",
    d: "m538.9 351c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m33.8 64h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m121.4 104.5h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m220.5 104.5h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m301.1 104.5h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m381.9 104.5h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m33.8 200.4h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m126.1 141.3l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m272 240.2v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m284.1 240.2h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m319.1 141.3v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m433.2 141.3l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m578.9 190.8c0 9.8-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.6 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m634.1 141.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m718.4 141.3l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m100.3 341.2l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m144.9 375.9h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m245.5 293.9v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m307.2 277l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m403.8 335.7l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.1 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s65",
    d: "m510.7 300.7c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m550.7 277h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s65",
    d: "m538.9 350.8c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m33.8 63.9h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m121.4 104.3h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m220.5 104.3h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m301.1 104.3h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m381.9 104.3h23v-35.3l33-63.6h-25.8l-18.6 39-18.7-39h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m33.8 200.3h34.8v-19.4h-34.8v-20.1h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m126.1 141.2l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m272 240.1v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m284.1 240.1h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m319.1 141.2v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m433.2 141.2l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m578.9 190.6c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m634.1 141.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m718.4 141.2l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m100.3 341.1l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m144.9 375.8h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m245.5 293.8v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m307.2 276.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m403.8 335.5l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10.1 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s66",
    d: "m510.7 300.5c3.6 7.4 5.4 16.1 5.4 25.8 0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m550.7 276.9h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s66",
    d: "m538.9 350.7c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m33.8 63.7h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m121.4 104.2h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m220.5 104.2h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.2-20.2 4.2h-14.4zm0-55.7h13.4c5 0 8.6-1.1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m301.1 104.2h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.2-20.1 4.2h-14.4zm0-55.7h13.3c5.1 0 8.7-1.1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m381.9 104.2h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m33.8 200.1h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m126.1 141l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m272 239.9v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m284.1 239.9h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m319.1 141v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m433.2 141l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m578.9 190.5c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.2-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m634.1 141l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.6h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m718.4 141l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m100.3 340.9l-16.6-64.1h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m144.9 375.7h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m245.5 293.7v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m307.2 276.8l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m403.8 335.4l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.3 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.5-3.1-8.6-2-2-5.6-3-10.5-3h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s67",
    d: "m510.7 300.4c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m550.7 276.8h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s67",
    d: "m538.9 350.5c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m33.8 63.6h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m121.4 104.1h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m220.5 104.1h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m301.1 104.1h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m381.9 104.1h23v-35.4l33-63.5h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m33.8 200h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m126.1 140.9l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m272 239.8v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m284.1 239.8h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m319.1 140.9v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m433.2 140.9l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m578.9 190.3c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10 16.9 17.5 3.6 7.4 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.2-8.4-9.5-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m634.1 140.9l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m718.4 140.9l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m100.3 340.8l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m144.9 375.5h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m245.5 293.5v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m307.2 276.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m403.8 335.2l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.7 12.1 11.5 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.4-6.9 7.9-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s68",
    d: "m510.7 300.3c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.4-5.4 25.8-3.7 7.5-9.4 13.3-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m550.7 276.6h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s68",
    d: "m538.9 350.4c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.5 3.8-5.6 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m33.8 63.4h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m121.4 103.9h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m220.5 103.9h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16 0 5.7-1.2 10.9-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3.1 2.1-2 3.1-4.8 3.1-8.5 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3.1-10.6-3.1h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m301.1 103.9h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16 0 5.7-1.3 10.9-3.8 15.6-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3.1 2.1-2 3-4.8 3-8.5 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3.1-10.7-3.1h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m381.9 103.9h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m33.8 199.8h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m126.1 140.7l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.7l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m272 239.6v-98.9h-25l-27.4 55.3-27.7-55.3h-25v98.9h23v-54.6l21 41.4h17.1l21-41.4v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m284.1 239.6h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m319.1 140.7v98.9h64.2v-19.2h-41.2v-79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m433.2 140.7l-18.6 39-18.7-39h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m578.9 190.2c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.2 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.2 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m634.1 140.7l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m718.4 140.7l-18.6 39-18.6-39h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m100.3 340.7l-16.6-64.2h-23.4l-17.1 64.3-14.5-64.3h-24.5l26.1 98.9h24.7l16.6-60.5 16.2 60.5h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m144.9 375.4h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m245.5 293.4v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m307.2 276.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m403.8 335.1l19.9 40.3h-26.2l-17.3-36.7h-9.2v36.7h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.3-1.6 12-4.9 17.2-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.7-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s69",
    d: "m510.7 300.1c3.6 7.4 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.3 6.2h-34.8v-98.9h34.8c11.3 0 20.8 2 28.3 6.1 7.5 4.1 13.2 10 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.2 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m550.7 276.5h-24.4l2.1 69.5h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s69",
    d: "m538.9 350.3c-4 0-7.3 1.2-9.9 3.7-2.6 2.6-3.9 5.7-3.9 9.4 0 3.5 1.3 6.6 3.9 9.1 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.1 0-3.7-1.3-6.8-3.8-9.4-2.6-2.5-5.8-3.7-9.6-3.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m33.8 63.3h35.7v40.5h23v-98.9h-23v38.6h-35.7v-38.6h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m121.4 103.8h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.8l-9.3-26.5-9.2 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m220.5 103.8h-22.9v-98.9h37.3c7.9 0 14.6 1.3 19.8 4 5.4 2.8 9.5 6.6 12.2 11.5 2.6 4.7 3.9 10.1 3.9 16 0 5.6-1.2 10.8-3.8 15.6-2.5 4.8-6.6 8.7-11.9 11.5-5.3 2.9-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2 3.1-4.8 3.1-8.6 0-3.8-1-6.6-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m301.1 103.8h-23v-98.9h37.4c7.9 0 14.5 1.3 19.8 4 5.4 2.8 9.5 6.6 12.1 11.5 2.7 4.7 4 10.1 4 16 0 5.6-1.3 10.8-3.8 15.6-2.6 4.8-6.6 8.7-12 11.5-5.3 2.9-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2 3-4.8 3-8.6 0-3.8-0.9-6.6-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m381.9 103.8h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m33.8 199.7h34.8v-19.4h-34.8v-20h43v-19.7h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m126.1 140.6l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m272 239.5v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m284.1 239.5h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m319.1 140.6v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m433.2 140.6l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m578.9 190.1c0 9.7-1.8 18.4-5.4 25.8-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.4 6.1h-34.7v-98.9h34.7c11.4 0 20.9 2.1 28.4 6.1 7.5 4.2 13.2 10.1 16.9 17.5 3.6 7.4 5.4 16.1 5.4 25.9zm-62.4 28.8h10.9c7.3 0 13-1.1 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.3-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-17-3.4h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m634.1 140.6l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m718.4 140.6l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m100.3 340.5l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m144.9 375.2h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m245.5 293.2v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m307.2 276.3l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.7l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m403.8 335l19.9 40.2h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.2 5.4 2.7 9.4 6.6 12.1 11.4 2.6 4.7 3.9 10 3.9 15.7 0 6.2-1.6 12-4.9 17.1-2.8 4.5-6.9 7.9-12.2 10.3zm-32.8-14.9h13.1c4.8 0 8.3-1 10.3-3.2 2.1-2.2 3.2-5 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s70",
    d: "m510.7 300c3.6 7.3 5.4 16 5.4 25.8 0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.2 7.5 4.1 13.2 10 16.9 17.5zm-57 54.6h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.2 8.3-9.4 1.8-4.3 2.7-9.7 2.7-16 0-6.2-0.9-11.6-2.7-16-1.7-4.2-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-16.9-3.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m550.7 276.3h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s70",
    d: "m538.9 350.1c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.2 2.6 2.5 5.9 3.8 9.9 3.8 3.8 0 7-1.3 9.6-3.8 2.5-2.5 3.8-5.6 3.8-9.2 0-3.6-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m33.8 63.2h35.7v40.4h23v-98.9h-23v38.7h-35.7v-38.7h-23v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m121.4 103.6h-24.2l36.2-98.9h23.3l36.2 98.9h-24.5l-7.4-21.5h-32zm32.8-40.7l-9.3-26.6-9.2 26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m220.5 103.6h-22.9v-98.9h37.3c7.9 0 14.6 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.2 11.4 2.6 4.8 3.9 10.2 3.9 16.1 0 5.6-1.2 10.8-3.8 15.5-2.5 4.8-6.6 8.7-11.9 11.6-5.3 2.8-12.1 4.3-20.2 4.3h-14.4zm0-55.8h13.4c5 0 8.6-1 10.6-3 2.1-2.1 3.1-4.9 3.1-8.6 0-3.8-1-6.7-3.1-8.7-2-2-5.6-3-10.6-3h-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m301.1 103.6h-23v-98.9h37.4c7.9 0 14.5 1.4 19.8 4.1 5.4 2.7 9.5 6.6 12.1 11.4 2.7 4.8 4 10.2 4 16.1 0 5.6-1.3 10.8-3.8 15.5-2.6 4.8-6.6 8.7-12 11.6-5.3 2.8-12 4.3-20.1 4.3h-14.4zm0-55.8h13.3c5.1 0 8.7-1 10.7-3 2.1-2.1 3-4.9 3-8.6 0-3.8-0.9-6.7-3-8.7-2-2-5.6-3-10.7-3h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m381.9 103.6h23v-35.3l33-63.6h-25.8l-18.6 38.9-18.7-38.9h-26l33.1 63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m33.8 199.6h34.8v-19.5h-34.8v-20h43v-19.6h-66v98.9h23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m126.1 140.5l36.1 98.9h-24.4l-7.5-21.5h-31.9l-7.6 21.5h-24.2l36.2-98.9zm-11.8 31.6l-9.2 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m272 239.4v-98.9h-25l-27.4 55.2-27.7-55.2h-25v98.9h23v-54.6l21 41.3h17.1l21-41.3v54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m284.1 239.4h23v-98.9h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m319.1 140.5v98.9h64.2v-19.3h-41.2v-79.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m433.2 141.5l-18.6 38.9-18.7-38.9h-26l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m578.9 189.9c0 9.8-1.8 18.5-5.4 25.8-3.7 7.5-9.4 13.4-16.9 17.5-7.5 4.1-17 6.2-28.4 6.2h-34.7v-98.9h34.7c11.4 0 20.9 2 28.4 6.1 7.5 4.1 13.2 10 16.9 17.5 3.6 7.3 5.4 16 5.4 25.8zm-62.4 28.9h10.9c7.3 0 13-1.2 17-3.4 4-2.2 6.7-5.3 8.4-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.6-2.7-16-1.7-4.1-4.4-7.3-8.4-9.5-4-2.3-9.7-3.5-17-3.5h-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m634.1 140.5l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.3 26.5h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m718.4 140.5l-18.6 38.9-18.6-38.9h-26.1l33.1 63.6v35.3h23v-35.3l33-63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m100.3 340.4l-16.6-64.2h-23.4l-17.1 64.4-14.5-64.4h-24.5l26.1 98.9h24.7l16.6-60.4 16.2 60.4h24.8l26.8-98.9h-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m144.9 375.1h22.9v-98.9h-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m245.5 293.1v-16.9h-68v20.2h39.8l-40.2 61.8v16.9h68.7v-20.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m307.2 276.2l36.2 98.9h-24.5l-7.4-21.5h-32l-7.5 21.5h-24.2l36.1-98.9zm-11.7 31.6l-9.2 26.5h18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m403.8 334.8l19.9 40.3h-26.2l-17.3-36.6h-9.2v36.6h-22.9v-98.9h37.1c7.9 0 14.5 1.4 19.7 4.1 5.4 2.8 9.4 6.6 12.1 11.4 2.6 4.8 3.9 10 3.9 15.8 0 6.2-1.6 11.9-4.9 17.1-2.8 4.4-6.9 7.8-12.2 10.2zm-32.8-14.8h13.1c4.8 0 8.3-1.1 10.3-3.2 2.1-2.2 3.2-5.1 3.2-8.8 0-3.6-1-6.4-3.1-8.5-2-2.1-5.6-3.1-10.5-3.1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s71",
    d: "m510.7 299.8c3.6 7.4 5.4 16.1 5.4 25.8 0 9.8-1.8 18.5-5.4 25.9-3.7 7.4-9.4 13.3-16.9 17.5-7.5 4-17 6.1-28.3 6.1h-34.8v-98.9h34.8c11.3 0 20.8 2.1 28.3 6.1 7.5 4.2 13.2 10.1 16.9 17.5zm-57 54.7h11c7.2 0 12.9-1.1 17-3.4 3.9-2.2 6.6-5.3 8.3-9.4 1.8-4.4 2.7-9.8 2.7-16.1 0-6.2-0.9-11.5-2.7-15.9-1.7-4.2-4.4-7.3-8.4-9.6-4-2.3-9.7-3.4-16.9-3.4h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m550.7 276.2h-24.4l2.1 69.6h20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s71",
    d: "m538.9 350c-4 0-7.3 1.3-9.9 3.8-2.6 2.5-3.9 5.6-3.9 9.3 0 3.5 1.3 6.6 3.9 9.2 2.6 2.5 5.9 3.7 9.9 3.7 3.8 0 7-1.2 9.6-3.7 2.5-2.6 3.8-5.7 3.8-9.2 0-3.7-1.3-6.8-3.8-9.3-2.6-2.5-5.8-3.8-9.6-3.8z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFamilyDay);
export default __webpack_public_path__ + "static/media/happy-family-day.c0dc8d6a104a5959fce1ead2adb12428.svg";
export { ForwardRef as ReactComponent };